import React from "react";

import ManageAgentComponent from "../../components/ManageAgent/ManageAgent";
import ErrorSnackbar from "../../widgets/Snackbar/ErrorSnackbar";
import { useAgentSearch } from "./hooks/useAgentSearch";

const ManageAgent = () => {
  const { formik, errorSnackbar, closeErrorSnackbar } = useAgentSearch();

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    touched,
    handleBlur,
    isSubmitting,
    setFieldValue,
  } = formik;

  return (
    <>
      <ManageAgentComponent
        values={values}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        touched={touched}
        handleBlur={handleBlur}
        isSubmitting={isSubmitting}
        setFieldValue={setFieldValue}
      />

      <ErrorSnackbar
        open={errorSnackbar.open}
        message={errorSnackbar.message}
        onClose={closeErrorSnackbar}
      />
    </>
  );
};

export default ManageAgent;
